<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:90px !important;">
    </div>
    <section class="section">
      <div class="card">
        <div class="card-image">
          <figure class="image">
            <qrcode-vue :value="urlconfirm" :size="size" level="H"></qrcode-vue>
          </figure>
          {{ urlconfirm }}
        </div>
        <div class="card-content">
          <div class="content">
            <b>ลูกค้ารถ</b> Honda {{ carInfo.Model }}<br>
            <b>เลขที่ตัวถัง</b> {{ carInfo.frameNo }}<br>
            <b>ชื่อลูกค้า</b> {{ carInfo.customerName }}<br>
            <b>เลขทะเบียนรถ</b> {{ carInfo.licenseNo }}<br>
          </div>
        </div>
      </div>
      <span class="error" v-show="alreadyConfirm">ลูกค้าเคยลงทะเบียนแล้ว</span>
    </section>
    <!-- <div>
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/intro_progress.jpg?alt=media&token=e1116019-6498-479e-8c28-ec2ac8078171" style="height:300px !important;">
    </div> -->
    <br><br>
  </div>
</template>
<style>
.error {
  color: red;
  font-size: 16px;
  font-weight: bold;
}
.banner {
  text-align: center;
  background-color: #000;
}
.section {
  padding: 1.5rem 1.5rem;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'Home',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liffId_Insurance_QRCode }, function (data) {})
  },
  components: {
    QrcodeVue
  },
  data: () => ({
    alreadyConfirm: false,
    urlconfirm: `line://app/1653760842-yoeKGZzR?`,
    size: 150,
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    branch: [],
    branchSelected: '',
    branchCode: '',
    carInfo: {
      bookingNo: '',
      invoiceNo: '',
      frameNo: '',
      customerName: '',
      Model: '',
      carYear: '',
      carColor: ''
    },
    carId: '',
    test: '',
    btn_action: 'Manual'
  }),
  mounted () {
    let _this = this
    _this.branch = this.$branchList
    // _this.getProfile()
    _this.test = window.location
    let queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?liff.state=', ''))
    queryString = queryString.replace('/qrcodeInsurance?', '')
    _this.test = queryString
    const params = new URLSearchParams(queryString)
    _this.carId = params.get('carId')
    _this.branch.map((item) => {
      _this.branchSelected = (item.id === _this.branchCode) ? item.name : _this.branchSelected
      return true
    })
    _this.urlconfirm += `carId=${_this.carId}`
    _this.getCarInfo()
  },
  methods: {
    getCarInfo () {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getInsuranceInfo?id=${_this.carId}`)
        .then(response => {
          _this.carInfo = response.data
          if (_this.carInfo.confirmTime) {
            _this.alreadyConfirm = true
          }
        })
    },
    manualSubmit () {
      if (!confirm('คุณต้องการทำรายการแบบ manual ใช่หรือไม่')) {
        return false
      }
      let _this = this
      _this.btn_action = 'กำลังดำเนินการ'
      _this.carInfo.branchId = _this.branchCode
      let params = {
        userId: -1,
        carId: _this.carId
      }
      this.$axios
        .post(`${this.$apiUrl}setInsuranceConfirm`, params)
        .then(response => {
          _this.btn_action = 'ดำเนินการเรียบร้อยแล้ว'
        })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    sendMessage () {
      let _this = this
      this.$liff.sendMessages([
        {
          type: 'text',
          text: 'You/\'ve successfully sent a message! Hooray!'
        },
        {
          type: 'sticker',
          packageId: '2',
          stickerId: '144'
        }
      ]).then(function () {
        _this.closeWindow()
        console.log('Message sent')
      }).catch(function (error) {
        console.log('Error sending message: ' + error)
      })
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QRCodeInsurance.vue